var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TableColumn',{attrs:{"label":_vm.column.name,"prop":_vm.column.key,"min-width":_vm.column.minWidth || 150,"sortable":_vm.column.sortable ? 'custom' : false},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._t("column",null,{"data":{
        field: _vm.column,
        row: scope.row,
        value: scope.row[_vm.column.key]
      }})]}}],null,true)},[_vm._l((_vm.column.children),function(item){return [(item.children && item.children.length)?_c('DynamicTableColumn',{key:item.key,attrs:{"coloumn":item}}):_c('TableColumn',{key:item.key,attrs:{"label":item.name,"prop":item.key,"min-width":item.minWidth || 150,"sortable":item.sortable ? 'custom' : false},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._t("column",null,{"data":{
            field: item,
            row: scope.row,
            value: scope.row[item.key]
          }})]}}],null,true)})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }